import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { TextPluralization } from 'components/TextPluralization';
import { FeedItemDto } from 'models/ApiModels';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: FeedItemDto;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const WidgetListResume: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { data: { statistics } } = props;

    return (
        <MuiContainer margin="dense">
            <MuiWidgetTitle title={t("Views.Publication.Widgets.WidgetListResume.BoxTitle")} />

            <MuiContainer margin="dense">
                <MuiColor variant="muted">
                    <table>
                        <tbody>
                            <tr>
                                <td align="right"><span>{statistics.views}</span></td>
                                <td><span><TextPluralization count={statistics.views} resource="Views.Publication.Widgets.WidgetListResume.ViewCount" /></span></td>
                            </tr>
                        </tbody>
                    </table>
                </MuiColor>
            </MuiContainer>

            
            {
                /* (Denis) Retiramos sugestões em listas; em listas colaborativas qualquer usuário com acesso à lista poderá adicionar novos itens
                 * 
                publication.publisher.id == Session.user.id &&
                <MuiColor variant="muted">
                    <table>
                        <thead>
                            <tr>
                                <td colSpan={2}>
                                    <Typography variant="button"><b>{t("Views.Publication.Widgets.WidgetListResume.SuggestionTitle")}</b></Typography>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td align="right"><span>{statistics.suggestions}</span></td>
                                <td><span>{t("Views.Publication.Widgets.WidgetListResume.ReceivedCount", { count: statistics.suggestions})}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{statistics.approvals}</span></td>
                                <td><span>{t("Views.Publication.Widgets.WidgetListResume.ApprovedCount", { count: statistics.approvals })}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{statistics.approvalPendings}</span></td>
                                <td><span>{t("Views.Publication.Widgets.WidgetListResume.PendingCount", { count: statistics.approvalPendings })}</span></td>
                            </tr>
                        </tbody>
                    </table>
            </MuiColor>
            */
            }
        </MuiContainer>
    );
};

export default WidgetListResume;